import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../constants/url";
import moment from "moment";
import ReactDropdown from "react-dropdown";
import Select from 'react-select'
import "react-dropdown/style.css";
import { api } from "../constants/api";
import getHeaders from "../utils/getHeaders";

const SlotBooking = () => {
  const initialSlotValue = {
    id: 0,
    amount: 0,
    startTime: "",
    endTime: "",
    isBooked: false,
  };
  const [slotDate, setSlotDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  });
  const [availableSlots, setAvailableSlots] = useState<any>([initialSlotValue]);
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");
  const [loading, setLoading] = useState(false)
  const [memberInfo, setMemberInfo] = useState<any>({})
  const [memberList, setMemberList] = useState([])
  const [selectedMember, setSelectedMember]:any = useState({})

  const getAvailableSlots = async () => {
    setLoading(true)
    const res = await api(true, `/admin/availableslots?date=${slotDate}`, 'get')
    //  axios.get(`${baseUrl}/availableslots?date=${slotDate}`);
    setAvailableSlots(res.data);
    setLoading(false)
  };

  const cancelSlotBooking = async (user_id:any, slot_booking_id:any) => {
    console.log(slot_booking_id)
    try{
      setLoading(true)
      const { authorization, membercode, memberid } = getHeaders();
      const res = await api(true, `/slotBooking/id/${slot_booking_id}`, 'get');
      // await getAvailableSlots()
      const bookedSlot = res.data.data;
      if (bookedSlot.order_id && bookedSlot.status === 'success') {
        const url = `${window.location.origin}/paymentRefund?userToken=${
          authorization.split(" ")[1]
        }&order_id=${
          bookedSlot.order_id
        }&memberCode=${membercode}&memberId=${memberid}&amount=${bookedSlot.amount}&slot_booking_id=${slot_booking_id}`;
        window.location.assign(url);
      } else if ((!bookedSlot.order_id && bookedSlot.status === 'success') || bookedSlot.status === 'pending') {
        const res = await api(true, `/admin/cancelSlot`, "post", {
          user_id: user_id,
          slot_booking_id: slot_booking_id,
          status: 'cancel'
        });
        if (res.status === 200) {
          getAvailableSlots()
          alert("Booking cancelled successfully")
        } else {
          alert("Booking cancellation failed")
        }
      }
    }catch(e:any){
      console.log(e)
    }finally{
      setLoading(false)
    }
  }

  const getMemberInfo = async () => {
    try {
      setLoading(true)
      let localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
      const res = await api(true, `/admin/get-all-members`, 'get', {}, { authorization: `Bearer ${localuser.token}` })
      setMemberInfo((res?.data?.data?.result || []).map((member:any) => ({ value: member.idNumber, label: `${member.memberName} (Member Code: ${member.memberCode})`, ...member })))
    } catch(error) {
      console.log(error, ' <== Error while fetching member info')
    } finally{
      setLoading(false)
    }
  }

  const setDefaultHeader = () => {
    if (
      localStorage.getItem("lastAuthTimeMillis") &&
      // @ts-ignore
      parseInt(localStorage.getItem("lastAuthTimeMillis")) >
        new Date().getTime() - 30 * 60 * 1000
    ) {
      // @ts-ignore
      axios.defaults.headers.common["MemberCode"] =
        localStorage.getItem("MemberCode");
      // @ts-ignore
      axios.defaults.headers.common["MemberId"] =
        localStorage.getItem("MemberId");
      // @ts-ignore
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("Authorization");
    } else {
      window.location.href = "/";
    }
  };

  const getTime = (str: any) => {
    return moment(str).format("LT");
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    // if(!selectedMember?.label){
    //   return alert("Please select member!")
    // }

    const body = {
      startTime: "",
      endTime: "",
      userId: selectedMember.value, //  TODO to be added (CURRENTLY STATIC)
      memberCode: selectedMember.memberCode,
      categoryCode: selectedMember.categoryCode
    };

    let amount:number = 0
    let sum = false

    for (let i = 0; i < availableSlots.length; i++) {
      if (getTime(availableSlots[i].startTime) === selectedStartTime) {
        body.startTime = moment(availableSlots[i].startTime).format('YYYY-MM-DD HH:mm:ss');
        sum = true
      }
      if(sum) {
        amount += parseFloat(availableSlots[i].amount)
      }
      if (getTime(availableSlots[i].endTime) === selectedEndTime) {
        body.endTime = moment(availableSlots[i].endTime).format('YYYY-MM-DD HH:mm:ss');
        sum = false
      }

    }

    // console.log(amount, slotDate + 'T' +moment(selectedStartTime, ["h:mm A"]).format("HH:mm:ss"), selectedEndTime, slotDate, ' <== debug booking..')
    // return

    const res = await api(true, `/admin/slotBook`, 'post', body)
    //  axios.post(`${baseUrl}/slotBook`, body);
    if (res.status === 200) {
      getAvailableSlots()
      let localuser = JSON.parse(localStorage.getItem('localuser') || '{}')
      axios.post(`/api/send-booking-sms`, {
        "memberId": selectedMember.value, // <=== TODO
        "receivedAmount": amount,
        "bookingFor": "Ground",
        "date": slotDate + 'T' +moment(selectedStartTime, ["h:mm A"]).format("HH:mm:ss")
      }, {
        headers: {
          authorization: `Bearer ${localuser.token}`,
          memberid: localuser.memberId || '',
          membercode: localuser.memberCode || ''
        }
      })
      alert("Booking Successfull!");
    }
  };

  useEffect(() => {
    if (slotDate) {
      getAvailableSlots();
    }
  }, [slotDate]);

  useEffect(() => {
    getMemberInfo()
  }, [])

  // useEffect(() => {
  //   setDefaultHeader();
  // }, []);

  const startSlots = availableSlots
    .filter((s:any) => new Date(s.startTime).getTime() > new Date().getTime())
    .filter((s:any) => !s.isBooked);

  

  const getEndSlots = () => {
    let endSlots = [];

    if (selectedStartTime) {
      let i = 0;
      for (; i < availableSlots.length; i++) {
        if (getTime(availableSlots[i].startTime) === selectedStartTime) {
          break;
        }
      }
      for (; i < availableSlots.length; i++) {
        if (availableSlots[i].isBooked) {
          break;
        }
        endSlots.push(availableSlots[i]);
      }
    }
    return endSlots;
  };

  if(loading) {
    return (
      <p>Loading...</p>
    )
  }

  const renderSlotBookingStatus = (data: any) => {
    if (data.isBooked === true && data.bookingStatus === 'success') {
      return <h4 style={{color: "lightgreen", fontWeight: "bold"}}>BOOKED</h4>
    } else if (new Date(data.startTime).getTime() < new Date().getTime()) {
      return <h4 style={{ color: "red" }}>NOT AVAILABLE</h4>
    } else if (data.isBooked === true && data.bookingStatus === 'pending') {
      return <h4>PENDING</h4>
    } else {
      return <h4>AVAILABLE</h4>
    }
  } 

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">SLOT BOOKING</h2>
      <div className="sloteDate">
        <h1>Select Booking Date</h1>
        <input
          type="date"
          value={slotDate}
          name="slotDate"
          onChange={(e) => setSlotDate(e.target.value)}
          min={moment().format("YYYY-MM-DD")}
        />
      </div>
      <form className="form-basePrice" onSubmit={handleSubmit}>
        <label>Start Time</label>
        <ReactDropdown
          options={startSlots.map((e:any) => getTime(e.startTime))}
          onChange={(e:any) => setSelectedStartTime(e.value)}
          placeholder="Select an option"
        />
        <label>End Time</label>
        <ReactDropdown
          options={getEndSlots().map((e) => getTime(e.endTime))}
          onChange={(e:any) => setSelectedEndTime(e.value)}
          placeholder="Select an option"
        />
        <div className="member-row">
          <label>Member</label>
          <Select
            options={memberInfo}
            onChange={(ele:any) => setSelectedMember(ele)}
            styles={{ 
              option(base: any, props: any) {
                  return {...base, color: 'black'}
              },
              control: (base: any) => ({
                ...base,
                width: '80%',
                minWidth: '300px'
              }),
              container: (base: any) => ({
                ...base,
                width: '100%'
              }),
              menu: (base: any) => ({
                ...base,
                zIndex: 9999
              }),
              menuList: (base: any) => ({
                ...base,
                zIndex: 9999
              })
            }}
          />
          <button className="submitbtn" type="submit">
            Book
          </button>
        </div>
        {/* <div>
          <button className="submitbtn" type="submit">
            Book
          </button>
        </div> */}
      </form>
      {slotDate && (
        <div className="table-responsive">
          <table className="tbl styled-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>START TIME</th>
                <th>END TIME</th>
                <th>AMOUNT</th>
                <th>STATUS</th>
                {/* <th>ACTION</th> */}
              </tr>
            </thead>
            <tbody>
              {slotDate && availableSlots.length > 0 ? (
                availableSlots.map((data:any, i:number) => {
                  return (
                    <tr key={i}>
                      <th>{i + 1}</th>
                      <th>{getTime(data.startTime)}</th>
                      <th>{getTime(data.endTime)}</th>
                      <th>{data.amount}</th>
                      <th>
                        {renderSlotBookingStatus(data)}
                      </th>
                      {/* <th>
                        {
                          (data.isBooked === true  && new Date(data.startTime).getTime() > new Date().getTime()) ? (
                            <button className="submitbtn" style={{ padding: "10px", fontSize: "18px", alignItems: "center", display: 'flex', justifyContent: 'center' }} onClick={() => cancelSlotBooking(data?.user_id, data?.slotBookingId)} >
                              Cancel
                            </button>
                          ):(
                            null
                          )
                        }
                      </th> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <th className="loader">No Slots Available On this Day</th>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SlotBooking;
